import { LogLevel } from "@azure/msal-browser";

export const b2cConfig = {
  clientId: "02f0a74c-1913-46e7-91e7-1cc33c07ab2a",
  url: "https://touchmars.b2clogin.com/touchmars.onmicrosoft.com",
  scopes: [
    "https://touchmars.onmicrosoft.com/touch-api/touch.read",
    "https://touchmars.onmicrosoft.com/touch-api/touch.write"
  ]
};

// Define policies for profile editing and password reset
const b2cPolicies = {
  names: {
    signUpSignIn: "b2c_1a_signup_signin",
    forgotPassword: "b2c_1a_passwordreset"
  },
  authorities: {
    signUpSignIn: {
      authority: `${b2cConfig.url}/b2c_1a_signup_signin`,
    },
    forgotPassword: {
      authority: `${b2cConfig.url}/b2c_1a_passwordreset`,
    }
  },
  authorityDomain: "touchmars.b2clogin.com"
};

export const msalConfig = {
  auth: {
    clientId: b2cConfig.clientId,
    authority: b2cPolicies.authorities.signUpSignIn.authority,
    knownAuthorities: [b2cPolicies.authorityDomain],
    redirectUri: "/redirect",//window.location.origin,//
    clientCapabilities: ["CP1"],
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: true,
  },
  system: {
    pollIntervalMilliseconds:0,
    allowNativeBroker: false, // Prevents Windows issues
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (!containsPii) {
          if (level === LogLevel.Error) console.error(message);
          if (level === LogLevel.Warning) console.warn(message);
        }
      }
    }
  }
};

export const loginRequest = {
  scopes: ["openid", "profile", "email", ...b2cConfig.scopes],
  authority: b2cPolicies.authorities.signUpSignIn.authority
};

export const resetPassword = {
  scopes: ["openid", "profile", "email", ...b2cConfig.scopes],
  authority: b2cPolicies.authorities.forgotPassword.authority
};